import { useContext } from "react";
import Modal from "react-overlays/Modal";
import Icon from "../icon";
import BorseContext from "../../context/borse";
import useBorseDocumentsConfirmMutation from "../../hooks/mutations/useBorseDocumentsConfirmMutation";
import useBorseDocumentsUploadMutation from "../../hooks/mutations/useBorseDocumentsUploadMutation";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const SendDocumentsModal = ({ show, closeModal, files, isUploadBeforeConfirmNeeded }) => {
  const { labels, currentRequest } = useContext(BorseContext);

  const {
    mutateAsync: uploadDocuments,
    isError: isUploadError,
    isFetching: isUploadFetching,
  } = useBorseDocumentsUploadMutation();

  const {
    mutateAsync: confirmUpload,
    isError,
    isFetching,
  } = useBorseDocumentsConfirmMutation(closeModal);

  const handleSendDocumentation = async () => {
    let response;
    if (isUploadBeforeConfirmNeeded) {
      response = await uploadDocuments({ request: currentRequest, files });
    }
    if (isUploadBeforeConfirmNeeded ? !!response : true) {
      await confirmUpload({ request: currentRequest });
    }
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--borse dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.WELFARE_BORSE_SEND_FILES_MODAL_TITLE ||
              "Once the documentation is sent you won't be able to edit the request anymore"}
          </h1>
          <p className="modal__description">
            {labels?.WELFARE_BORSE_SEND_FILES_MODAL_TEXT ||
              "Do you want to send the documentation?"}
          </p>
          <div className="modal__buttons">
            <button className="button secondary" onClick={closeModal}>
              {labels?.WELFARE_BORSE_SEND_FILES_MODAL_SECONDARY || "No, don't send"}
            </button>
            <button className="button primary" onClick={handleSendDocumentation}>
              {(isFetching || isUploadFetching) && <span className="loading-spinner" />}
              {labels?.WELFARE_BORSE_SEND_FILES_MODAL_PRIMARY || "Send"}
            </button>
          </div>
          {(isError || isUploadError) && (
            <p className="modal__error">
              {labels?.WELFARE_BORSE_ERROR_SAVING_REQUEST || "Error saving request"}
            </p>
          )}
        </div>
      </>
    </Modal>
  );
};

export default SendDocumentsModal;
